/*
charts
*/
/**
* Charts Management
*/

/************************************************
Making their values dynamic
*************************************************/

//-- get the right modules based on the PAGE_CODE
if (PAGE_CODE === 'dshbrdp') {
  var modules = $("[data-type=module][data-state-type]");
}
else {
  var modules = $("[class^=shar_chart_text_w_cta]");
}

//-- go through the modules found
modules.each(function() {

  //-- init
  var state_type; // state type, otb mmb or cb
  var amount_max; // the maximum amount the chart can display
  var __chart_max_value = 250;

  //-- get current module
  var _module = $(this);

  //-- get numeric value of the chart
  var _amount_el = _module.find(".actual-amount .amount");
  var amount = _amount_el.text();
  amount = amount.replace(/[^0-9.]/g, '');

  //-- get state type of/for the _module
  if (PAGE_CODE === 'dshbrdp') {
    state_type  = _module.attr('data-state-type');
  }
  else if (PAGE_CODE === 'mbp') {
    state_type = 'mmb';
  }
  else if (PAGE_CODE === 'wrp') {
    state_type = 'otb';
  }
  else if (PAGE_CODE === 'cbp' || PAGE_CODE === 'hmp_in') {
    state_type = 'cb';
  }

  //-- get max amount for the _module
  switch (state_type) {
    case 'mmb':
    amount_max = daysInCurrentMonth();
    break;
    case 'otb':
    amount_max = 90;
    break;
    case 'cb':
      //-- get all options and extract the maximum CB amount (from bundle.js, only when on CB side)
      if (PAGE_CODE === "cbp" || PAGE_CODE === "dshbrdp" || PAGE_CODE === 'hmp_in') {
        var page_options = group.select(PAGE_CODE_NAME).Options;
        amount_max = select_in_obj_arr(page_options, "Code_Name", "cb-max");
        amount_max = amount_max.Val;
      }
      if (!amount_max || typeof amount_max === "undefined") amount_max = 250;
    break;
    default: break;
  }

  //-- get circle chart
  var _chart_circle = _module.find(".graph circle[stroke-dasharray]");

  //-- get inline chart
  var _chart_line = _module.find(".therm .inner-therm");

  //-- if chart circle is available...
  if (typeof _chart_circle !== "undefined") {
    var circle_value = Math.floor((amount * __chart_max_value) / amount_max);
    _chart_circle.attr('stroke-dasharray', circle_value + ',1000');
  }

  //-- if chart line is available...
  if (typeof _chart_line !== "undefined" && state_type === "cb") {
    var line_value = Math.floor((amount * 100) / amount_max);
    setTimeout(function() { _chart_line.width(line_value+"%"); }, 10);
  }
});
